import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CSVLink } from "react-csv";
import { generateFees } from "utils/downloads";
import { FeeModel } from "providers/loans/fee.model";
import { Button } from "@chakra-ui/react";

interface DownloadButtonProps {
	selectedFees: FeeModel[];
}

export function DownloadButton({ selectedFees }: DownloadButtonProps) {
	return selectedFees.length > 0 ? (
		<CSVLink
			data={generateFees(selectedFees)}
			filename={`fee_payments_export_${new Date().getTime()}.csv`}
		>
			<Button
				size="xs"
				variant="outline"
				leftIcon={<FontAwesomeIcon icon={["fas", "download"]} />}
			>
				Export
			</Button>
		</CSVLink>
	) : (
		<></>
	);
}
